<template>
  <div>
  <div  class="basic-margin cd-title-label"><b>商家列表</b>
    <el-col style="cursor:pointer;padding-left:77px;margin-top:-22px;">
      <el-tooltip placement="top" >
      <div slot="content">
        以下列表展示合伙人对客户线索使用情况。（为实时数据）<br/><br/>
        线索账户余额：指合伙人线索包的可用余额<br/><br/>
        已充值金额：指合伙人往线索包账户累计充值金额<br/><br/>
        线索支出：指合伙人累计购买线索累计花费金额<br/><br/>
        有效线索量：指合伙人累计购买有效线索的条数<br/><br/>
        重复线索量：指合伙人累计获得重复线索的条数<br/><br/>
        指定线索量：指合伙人累计获得指定线索的条数<br/><br/>
        线索评价：指合伙人累计查看线索后进行评价的结果统计
        </div>
        <span class="el-icon-information" ></span>
      </el-tooltip>
    </el-col>

  </div>
  <el-table
    :data="data"
    border
    style="width: 100%">
    <el-table-column
      prop="businessName"
      label="商家名称">
    </el-table-column>
    <el-table-column
      prop="rechargeAmount"
      label="已充值金额">
    </el-table-column>
    <el-table-column
      prop="clueBalance"
      label="线索账户余额">
    </el-table-column>
    <el-table-column
      prop="clueExpenditure"
      label="线索支出">
    </el-table-column>
    <el-table-column
      prop="effectiveClueAmount"
      label="有效线索量">
    </el-table-column>
    <el-table-column
      prop="repeatClueAmount"
      label="重复线索量">
    </el-table-column>
    <el-table-column
      prop="specifyClueAmount"
      label="指定线索量">
    </el-table-column>
    <el-table-column
        :width=350
      label="线索评价">
      <template scope="scope">
        <span>
          <el-rate
            disabled
              v-model="highPraise" :max=3 text-color="#ff9900"
              :text-template=scope.row.goodCountString
              show-text>
          </el-rate></span>
      <span><el-rate
        disabled
          v-model="middlePraise" :max=3 text-color="#ff9900"
          :text-template=scope.row.commonCountString
          show-text>
      </el-rate>
      </span>
      <span>
        <el-rate
          disabled
          v-model="lowPraise" :max=3 text-color="#ff9900"
            :text-template=scope.row.badCountString
            show-text>
        </el-rate>
      </span>
      <span>
        <el-rate
          disabled
          v-model="noPraise" :max=3 text-color="#ff9900"
            :text-template=scope.row.noCountString
            show-text>
        </el-rate>
      </span>

      </template>

    </el-table-column>
  </el-table>
  <el-pagination
  class="row basic-margin"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[5, 10, 20, 50]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalCount">
    </el-pagination>
</div>
</template>
<style media="screen" >
  .el-table .info-row {
    background: #c9e5f5;
  }
  .el-table .positive-row {
    background: #e2f0e4;
  }
  .cd-title-label{
    margin-top: 25px;
    color: rgb(32, 160, 255);
    font-size: 17px;
    margin-bottom: 10px;
  }
</style>
<script>
import DataMonitorModel from '../../../framework/models/dataMonitorModel'
import BasicPager from '../../../mixins/BasicPager'
export default {
  name: 'clue-data-monitor-business',
  extends: BasicPager,
  data: function () {
    return {
      data: [
      ],
      currentPage: 1, // 起始
      pageSize: 5, // 步长
      totalCount: 0, // 总条数
      highPraise: 3,
      middlePraise: 2,
      lowPraise: 1,
      noPraise: 0
    }
  },
  created: function () {
    this.loadList()
  },
  methods: {
    handleSizeChange (val) { // 监听页数变化
      this.pageSize = val
      this.loadList()
    },
    handleCurrentChange (val) { // 监听页码变化
      this.currentPage = val
      this.loadList()
    },
    loadList: function () {
      let _this = this
      let params = {
        currentPage: _this.currentPage,
        pageSize: _this.pageSize
      }
      let listener = {
        success: function (dataInfo) {
          for (var i = 0; i < dataInfo.data.length; i++) {
            let count = dataInfo.data[i].goodCount + dataInfo.data[i].commonCount + dataInfo.data[i].badCount + dataInfo.data[i].noCount
            if (count == 0) {
              dataInfo.data[i].goodCountString = ' 好评' + 0 + '个，' + '好评率' + 0 + '%'
              dataInfo.data[i].commonCountString = ' 中评' + 0 + '个，' + '中评率' + 0 + '%'
              dataInfo.data[i].badCountString = ' 差评' + 0 + '个，' + '差评率' + 0 + '%'
              dataInfo.data[i].noCountString = ' 未评' + 0 + '个，' + '未评率' + 0 + '%'
            } else {
              dataInfo.data[i].goodCountString = ' 好评' + dataInfo.data[i].goodCount + '个，' + '好评率' + (dataInfo.data[i].goodCount / count * 100).toFixed(2) + '%'
              dataInfo.data[i].commonCountString = ' 中评' + dataInfo.data[i].commonCount + '个，' + '中评率' + (dataInfo.data[i].commonCount / count * 100).toFixed(2) + '%'
              dataInfo.data[i].badCountString = ' 差评' + dataInfo.data[i].badCount + '个，' + '差评率' + (dataInfo.data[i].badCount / count * 100).toFixed(2) + '%'
              dataInfo.data[i].noCountString = ' 未评' + dataInfo.data[i].noCount + '个，' + '未评率' + (dataInfo.data[i].noCount / count * 100).toFixed(2) + '%'
            }
          }
          _this.data = dataInfo.data
          _this.totalCount = dataInfo.recordsTotal
        }
      }
      DataMonitorModel.findBusinessDataList(this, params, listener)
    }
  }
}
</script>
